// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'color'>
const SvgFiletypePdf = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 159 206"
    {...props}
  >
    <path
      fill="#999"
      d="M0 4a4 4 0 0 1 4-4h95.807c2.366 0 4.637.932 6.322 2.595l33.193 32.762A9 9 0 0 1 142 41.762V183a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M4 6a2 2 0 0 1 2-2h92a2 2 0 0 1 2 2v26.5c0 5.523 4.477 10 10 10h26a2 2 0 0 1 2 2V181a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
    />
    <path
      fill="#999"
      d="M105.589 128.865h-69.34c-.669 0-1.31-.32-1.782-.888s-.737-1.34-.737-2.145c.001-.803.267-1.572.74-2.139.472-.567 1.111-.885 1.778-.885h69.341c.666 0 1.305.318 1.776.885.472.568.736 1.337.736 2.139.001.398-.063.792-.189 1.16a3.1 3.1 0 0 1-.544.984 2.55 2.55 0 0 1-.816.658 2.15 2.15 0 0 1-.963.231M105.589 94.704h-69.34c-.668 0-1.307-.318-1.78-.885-.472-.567-.738-1.336-.74-2.14 0-.804.266-1.575.738-2.144.473-.569 1.113-.888 1.781-.888h69.341c.331 0 .658.078.963.231s.582.376.816.658c.233.281.418.616.544.984s.19.762.189 1.16c0 .802-.264 1.571-.736 2.138-.471.568-1.11.886-1.776.886M105.589 111.785h-69.34c-.669 0-1.31-.32-1.782-.889-.472-.568-.737-1.34-.737-2.144.001-.803.267-1.572.74-2.139.472-.567 1.111-.886 1.778-.886h69.341c.666 0 1.305.319 1.776.886s.736 1.337.736 2.139c.001.398-.063.792-.189 1.16a3.1 3.1 0 0 1-.544.984 2.55 2.55 0 0 1-.816.658 2.15 2.15 0 0 1-.963.231M78.24 77.624H36.248c-.667 0-1.306-.318-1.778-.885-.473-.567-.739-1.337-.74-2.14 0-.804.265-1.575.737-2.144.473-.569 1.113-.888 1.781-.888H78.24c.666.002 1.305.322 1.776.891s.736 1.339.736 2.142c-.002.801-.267 1.57-.738 2.136-.47.567-1.109.886-1.774.888M78.24 60.544H36.248c-.667 0-1.306-.319-1.778-.886-.473-.567-.739-1.336-.74-2.139 0-.804.265-1.576.737-2.144.473-.57 1.113-.888 1.781-.888H78.24c.666.002 1.305.322 1.776.89.471.57.736 1.34.736 2.142-.002.802-.267 1.57-.738 2.137-.47.566-1.109.886-1.774.888M103.925 54.487H90.67c-2.31 0-4.184 2.022-4.184 4.518V73.32c0 2.495 1.873 4.518 4.184 4.518h13.255c2.31 0 4.183-2.023 4.183-4.518V59.005c0-2.496-1.873-4.518-4.183-4.518M23 166a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4H27a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M114.86 185.881v4.841c0 1.957.053 2.935.212 3.967h-4.814c.159-.979.238-2.116.238-3.915v-14.045c0-1.587-.053-2.406-.212-3.623 1.058.053 1.772.079 3.597.079h7.697c1.773 0 2.672-.053 3.809-.185v4.258c-1.005-.132-2.063-.185-3.782-.185h-6.745v5.026h5.422c1.746 0 2.698-.053 3.783-.185v4.152c-1.005-.132-2.116-.185-3.783-.185zM87.218 191.118v-14.362c0-1.64-.053-2.46-.239-3.65 1.058.053 1.72.079 3.624.079h5.158c3.253 0 5.66.794 7.38 2.46 1.93 1.878 2.935 4.629 2.935 8.094 0 3.623-1.058 6.506-3.094 8.49-1.746 1.666-4.073 2.46-7.195 2.46h-5.184c-1.798 0-2.513.026-3.597.079.159-1.137.212-1.957.212-3.65m4.364-.264h3.862c1.957 0 3.28-.476 4.284-1.534 1.191-1.244 1.826-3.148 1.826-5.502 0-2.407-.556-4.153-1.693-5.316-1.005-1.032-2.328-1.482-4.444-1.482h-3.835zM70.942 194.689h-4.76c.158-1.084.21-2.142.21-3.65v-14.31c0-1.349-.052-2.354-.21-3.623a71 71 0 0 0 3.623.079h5.634c2.671 0 4.629.661 5.951 1.984 1.11 1.111 1.72 2.777 1.72 4.761 0 2.116-.636 3.862-1.879 5.105-1.349 1.375-3.306 2.036-5.872 2.036h-4.628v3.915c0 1.508.053 2.645.211 3.703m-.211-11.347h4.523c2.142 0 3.359-1.19 3.359-3.28 0-.952-.265-1.746-.794-2.275-.555-.608-1.375-.872-2.565-.872H70.73zM57 190.113h4.576v4.576H57z"
    />
  </svg>
)
export default SvgFiletypePdf
